import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { Url } from "../config/config";
import { isLoggedIn } from "../utils";
import useButtonLoader from "../hooks/useButtonLoader";

export default function ChangePassword() {
  const [old_password, OldState] = useState("");
  const [new_password, newState] = useState("");
  const [confirm_password, confirmState] = useState("");
  const [errorField, setErrorField] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Update Password",
    "Please wait..."
  );

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!old_password) {
      errorField["old_password"] = "Please enter old password";
      formIsValid = false;
    }

    if (!new_password) {
      errorField["new_password"] = "Please enter new password";
      formIsValid = false;
    }

    if (!confirm_password) {
      errorField["confirm_password"] = "Please enter confirm password";
      formIsValid = false;
    }
    if (confirm_password != new_password) {
      confirmState("");
      errorField["confirm_password"] =
        "New password must be equal to confirm password";
      formIsValid = false;
    }
    setErrorField(errorField);
    return formIsValid;
  };

  //*********************Update Password************************************ */
  const handelUpdatePassword = async (event) => {
    try {
      event.preventDefault();
      if (handleValidation()) {
        setSubmitLoading(true);
        const token = isLoggedIn().token;
        const res = await axios({
          url: `${Url}/changePassword`,
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            oldPassword: old_password,
            newPassword: new_password,
          },
        });
        setSubmitLoading(false);
        if (res.data.status == 200) {
          OldState("");
          newState("");
          confirmState("");
          toast.success(res.data.message);
        } else if (res.data.status === 419) {
          toast.error(res.data.message);
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <React.Fragment>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <h4 className="Title">Change password</h4>
            <form method="POST">
              <div className="PasswordArea">
                <div className="row">
                  <div className="col-sm-7">
                    <div className="form-group">
                      <label>Enter old password</label>
                      <input
                        type="password"
                        value={old_password}
                        onChange={(e) => OldState(e.target.value)}
                        name="old_password"
                        className="form-control"
                        placeholder="xxxxxxxxxx"
                      />
                      <span style={{ color: "red" }} className="error">
                        {errorField.old_password}
                      </span>
                    </div>
                    <div className="form-group">
                      <label>New password</label>
                      <input
                        type="password"
                        value={new_password}
                        onChange={(e) => newState(e.target.value)}
                        name="new_password"
                        className="form-control"
                        placeholder="xxxxxxxxxx"
                      />
                      <span style={{ color: "red" }} className="error">
                        {errorField.new_password}
                      </span>
                    </div>
                    <div className="form-group">
                      <label>Re-enter New password</label>
                      <input
                        type="password"
                        value={confirm_password}
                        onChange={(e) => confirmState(e.target.value)}
                        name="confirm_password"
                        className="form-control"
                        placeholder="xxxxxxxxxx"
                      />
                      <span style={{ color: "red" }} className="error">
                        {errorField.confirm_password}
                      </span>
                    </div>
                    <button
                      className="mt-3 button"
                      onClick={handelUpdatePassword}
                      ref={submitButtonElement}
                    >
                      Update Password
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
